// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__E8dE1 div {
  display: flex; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/Input/TimeInput/styles.module.scss"],"names":[],"mappings":"AAAA;EAEI,aAAa,EAAA","sourcesContent":[".container {\n  & div {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__E8dE1`
};
export default ___CSS_LOADER_EXPORT___;
